module.exports = __webpack_public_path__ + "static/media/circle-x.253ea7d1.svg";